import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "../../characteristic.module.scss";
import { CharacteristicCustomForm } from "../../characteristicCustomForm";
import { CharacteristicHistory } from "../../characteristicHistory";
import { CharacteristicTissue } from "../../characteristicTissue";
import { CharacteristicTouch } from "../../characteristicTouch";
import { CharacteristicClassification } from "../../characteristicClassification";
import { useParams } from "react-router-dom";
import { CharacteristicProgress } from "../CharacteristicProgress";
import { useReadOnly } from "../../../../../hooks/useReadOnly";
import { usePermissions } from "../../../../../hooks/usePermissions";

export const useTabList = ({ assessmentDetails, overrideToggle, setShowWound, updateCharStatus, getCharDetails }) => {
  const { patientId, assessmentId } = useParams();
  const isReadOnly = useReadOnly();
  const { hasPermission } = usePermissions();
  const ne1getWounAssessmentDetailData = useSelector((state) => state.patient.ne1getWounAssessmentDetail);
  const characteristicTabsData = useSelector((s) => s.patient.minimumDatasetInfo?.characteristics);

  const [tabListNew, setTabListNew] = useState([]);

  useEffect(() => {
    if (!characteristicTabsData?.length) return;

    const history = characteristicTabsData.find((item) => item.key === "history");

    const cause = characteristicTabsData.find((item) => item.key === "cause");

    const historyCauseCompleted = history?.isCompleted === 1 && cause?.isCompleted === 1 ? 1 : 0;

    const finalTabNew = characteristicTabsData
      ?.map((data) => {
        if (data.key === "cause") {
          return null;
        }

        const isHistoryCause = data.key === "history";

        const sharedProps = {
          styles,
          patientId,
          assessmentId,
          assessmentDetails,
          getCharDetails,
          overrideToggle,
          isCompleted: isHistoryCause ? historyCauseCompleted : data?.isCompleted,
          historyCauseCompleted,
          characteristicTabsData,
          isReadOnly,
          hasPermission,
        };

        const base = {
          completed: isHistoryCause ? historyCauseCompleted : data.isCompleted,
          name: isHistoryCause ? "History/Cause" : data.value,
          key: data.key,
        };

        if (!data?.isCustomForm) {
          switch (data.key) {
            case "history":
              return {
                ...base,
                content: <CharacteristicHistory {...sharedProps} setShowWound={false} />,
              };

            case "cause":
              return null;

            case "tissuetype":
              return {
                ...base,
                content: <CharacteristicTissue {...sharedProps} />,
              };

            case "touch&viewdetails":
              return {
                ...base,
                content: <CharacteristicTouch {...sharedProps} setShowWound={setShowWound} updateCharStatus={updateCharStatus} />,
              };

            case "classification":
              return {
                ...base,
                content: <CharacteristicClassification {...sharedProps} setShowWound={setShowWound} />,
              };

            case "setprogress":
              return {
                ...base,
                content: <CharacteristicProgress {...sharedProps} />,
              };

            default:
              return null;
          }
        }

        return {
          ...base,
          content: (
            <CharacteristicCustomForm
              name={data.key}
              formId={data.isCustomForm}
              queryParam={{ ne1Id: patientId, assessmentId }}
              assessmentDetails={assessmentDetails}
              isCompleted={data?.isCompleted}
              historyCauseCompleted={historyCauseCompleted}
              characteristicTabsData={characteristicTabsData}
              isReadOnly={isReadOnly}
              hasPermission={hasPermission}
            />
          ),
        };
      })
      .filter(Boolean);

    if (finalTabNew) {
      setTabListNew(finalTabNew);
    }
  }, [ne1getWounAssessmentDetailData, characteristicTabsData, assessmentDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  return tabListNew;
};
